import type * as PanelTypes from '../../state/views/panel/types';
import type * as PanelBankSectionConfigTypes from '../../state/views/panelBankSectionConfig/types';
import {type RunHistoryKeyInfo} from '../../types/run';
import {type OrganizedSettings} from '../PanelBank/types';

export type PanelContainerProps = {
  defaultMoveToSectionRef?: PanelBankSectionConfigTypes.Ref;
  disableRunLinks?: boolean;
  historyKeyInfo?: RunHistoryKeyInfo;
  isReadOnly?: boolean; // whether user can edit the panel
  isProjectReadOnly?: boolean; // whether user can edit project level resources (e.g. reports)
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
  panelRef: PanelTypes.Ref;
  inheritedSettings?: OrganizedSettings;
  shouldRenderContent?: boolean;
  shouldTurnOnComments?: boolean;
  onContentHeightChange?(h: number): void;
  mode?: string;
};

export enum PanelPopupMode {
  EDIT,
  FULL_SCREEN,
  VIEW_SPEC,
}

export interface PanelProps {
  currentHeight: number;
  defaultMoveToSectionRef?: PanelBankSectionConfigTypes.Ref;
  disableRunLinks?: boolean;
  onContentHeightChange?(h: number): void;
  shouldRenderContent?: boolean;
  shouldTurnOnComments: boolean;
  /** @deprecated use values from useDetectPanelVariant() instead */
  mode?: string;
}

export enum ExportType {
  CSV,
  Image,
}
